import { render } from "./TotalCompany.vue?vue&type=template&id=0258797a"
import script from "./TotalCompany.vue?vue&type=script&lang=js"
export * from "./TotalCompany.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__